export const CHECKOUT_URL =
  'https://barre-instructor-ready.impultienda.ar/checkout'

export function trackCheckout() {
  const fbq = (
    window as Window & {
      fbq?: (...args: unknown[]) => void
    }
  ).fbq
  fbq?.('track', 'InitiateCheckout', {
    content_name: 'Barre Instructor Ready',
    value: 26.9,
    currency: 'USD',
  })
}
